// Fade-up on scroll
(function () {
  const obs = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.style.opacity = '1';
        e.target.style.transform = 'translateY(0)';
        obs.unobserve(e.target);
      }
    });
  }, { threshold: .08 });

  document.querySelectorAll('.prod-card, .sbox, .fb-cards').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(24px)';
    el.style.transition = 'opacity .6s ease, transform .6s ease';
    obs.observe(el);
  });
})();

// Cart count + AJAX add-to-cart
(function () {
  async function refreshCartCount() {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      const btn = document.getElementById('cartBtn');
      if (btn) {
        btn.innerHTML = `🛍️ ${window.HolyShop?.cartLabel || 'Panier'} (${cart.item_count})`;
      }
    } catch (err) {
      console.warn('Cart fetch failed', err);
    }
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    const original = btn.textContent;
    btn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (!res.ok) throw new Error('Add failed');
      btn.textContent = '✓ Ajouté !';
      btn.style.background = 'var(--teal)';
      btn.style.color = '#fff';
      await refreshCartCount();
    } catch (err) {
      btn.textContent = 'Erreur';
    } finally {
      setTimeout(() => {
        btn.textContent = original;
        btn.style.background = '';
        btn.style.color = '';
        btn.disabled = false;
      }, 2000);
    }
  });

  refreshCartCount();
})();

// Sans Jugement carousel (stack 3D auto-rotate)
(function() {
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (REDUCED) return;

  document.querySelectorAll('[data-sj-carousel]').forEach(function(el) {
    var cards = [].slice.call(el.querySelectorAll('.sj-carousel__card'));
    if (cards.length < 2) return;

    var current = 0;
    var paused = false;

    function next() {
      if (paused) return;
      var leaving = cards[current];
      current = (current + 1) % cards.length;
      var entering = cards[current];

      leaving.classList.remove('sj-carousel__card--active');
      leaving.classList.add('sj-carousel__card--leaving');

      requestAnimationFrame(function() {
        entering.classList.add('sj-carousel__card--active');
      });

      setTimeout(function() {
        leaving.classList.remove('sj-carousel__card--leaving');
      }, 650);
    }

    el.addEventListener('mouseenter', function() { paused = true; });
    el.addEventListener('mouseleave', function() { paused = false; });

    setInterval(next, 3000);
  });
})();
